import { render } from "./AboutSection.vue?vue&type=template&id=2bacc720&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=2bacc720&scoped=true&lang=css"

import exportComponent from "/home/brandon/Code/Clients/PhilipComan/specialty-studio-vuetify-theme-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bacc720"]])

export default __exports__